import React, { Component } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { CartProvider } from './context/CartContext';
// Components
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { CartDrawer } from './components/CartDrawer';
// Pages
import { Home } from './pages/Home';
import { Shop } from './pages/Shop';
import { ProductDetail } from './pages/ProductDetail';
import { Checkout } from './pages/Checkout';
import { OrderConfirmation } from './pages/OrderConfirmation';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { FAQ } from './pages/FAQ';
function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="min-h-screen flex flex-col bg-[#F7F8FA] font-sans text-gray-900" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex-grow" data-id="element-2">{children}</main>
      <Footer data-id="element-3" />
      <CartDrawer data-id="element-4" />
      <Toaster position="bottom-right" data-id="element-5" />
    </div>;
}
export function App() {
  return <CartProvider data-id="element-6">
      <Router data-id="element-7">
        <Layout data-id="element-8">
          <Routes data-id="element-9">
            <Route path="/" element={<Home data-id="element-11" />} data-id="element-10" />
            <Route path="/shop" element={<Shop data-id="element-13" />} data-id="element-12" />
            <Route path="/shop/:category" element={<Shop data-id="element-15" />} data-id="element-14" />
            <Route path="/product/:slug" element={<ProductDetail data-id="element-17" />} data-id="element-16" />
            <Route path="/checkout" element={<Checkout data-id="element-19" />} data-id="element-18" />
            <Route path="/order-confirmation" element={<OrderConfirmation data-id="element-21" />} data-id="element-20" />
            <Route path="/about" element={<About data-id="element-23" />} data-id="element-22" />
            <Route path="/contact" element={<Contact data-id="element-25" />} data-id="element-24" />
            <Route path="/faq" element={<FAQ data-id="element-27" />} data-id="element-26" />
            {/* Redirect cart page to drawer for now, or could build a full cart page */}
            <Route path="/cart" element={<Navigate to="/checkout" replace data-id="element-29" />} data-id="element-28" />
            <Route path="*" element={<Navigate to="/" replace data-id="element-31" />} data-id="element-30" />
          </Routes>
        </Layout>
      </Router>
    </CartProvider>;
}